import { IRouteObj } from "interface/common";
import React from "react";
import PageUploadAudio from "view/PageUploadAudio/PageUploadAudio";

//base
export const linkBasePath = "/dashboard";
export const linkApiBasePath = "/api";
/** Base path for Bluejay PD Abstraction FastAPI router */
export const linkBluejayApiBase = "/synthia/ai/pd-abstraction";
export const linkAppDBApiBase = "synthia/ai/appdb/v1";

//No Auth Routes
export const linkPageBase = "/";
export const linkPageLogin = "/login";
export const linkPageUploadAudio = "/upload-audio";
export const linkPageIntelligence = "/intelligence/:uuid";
export const linkPageAudioAnalysis = "/audio-analysis";
export const linkPageUnauthorized = "/unauthorized";

//links
export const linkAuthRoute = "/console";
export const linkPageMenu = "/menu";
export const linkPageView1 = "/view1";
export const linkPageView2 = "/view2";
export const linkPageView3 = "/view3";
export const linkPageView4 = "/view4";
export const linkPageCart = "/cart";
export const linkPageFormNameCreate = "/formname/create";
export const linkPageFormNameView = "/formname/view/:uid"; //? add this to make it optional
export const linkPageBranchCreate = "/branch/create";
export const linkPageBranchView = "/branch/view/:uid"; //? add this to make it optional
export const linkPageMode = "/mode";

//linknames
export const linkNamePageLogin = "Login";
export const linkNamePageMenu = "Menu";
export const linkNamePageView1 = "View1";
export const linkNamePageView2 = "View2";
export const linkNamePageFormAutomation = "FormAutomation";
export const linkNamePageBranch = "Branch";
export const linkNamePageUploadPDF = "UploadPDF";
export const linkNamePageIntelligence = "Intelligence";
export const linkNamePageRebateAnalysis = "RebateAnalysis";
export const linkNamePageUnauthorized = "Unauthorized";

//imports
const NavigationMenuPage = React.lazy(() => import("./page/NavigationMenuPage/NavigationMenuPage"));
const View1 = React.lazy(() => import("./view/View1/View1"));
const View2 = React.lazy(() => import("./view/View2/View2"));
const View3 = React.lazy(() => import("./view/View3/View3"));
const View4 = React.lazy(() => import("./view/View4/View4"));
const FormAutomation = React.lazy(() => import("./view/PageFormAutomation/PageFormAutomation"));
const Branch = React.lazy(() => import("./view/PageBranch/Branch"));
const PageMode = React.lazy(() => import("./view/PageMode/PageMode"));
const PageUploadPDF = React.lazy(() => import("./view/PageUploadPDF/PageUploadPDF"));
const PageRebateAnalysis = React.lazy(() => import("./view/PageRebateAnalysis/PageRebateAnalysis"));
const PageAudioAnalysis = React.lazy(() => import("./view/PageAudioAnalysis/PageAudioAnalysis"));
const PageUnauthorized = React.lazy(() => import("./view/PageUnauthorized"));

//routes
const routes: IRouteObj[] = [
  {
    path: linkPageMenu,
    exact: true,
    name: linkNamePageMenu,
    component: NavigationMenuPage,
  },
  {
    path: linkPageView1,
    exact: true,
    name: linkNamePageView1,
    component: View1,
  },
  { path: linkPageView2, name: linkNamePageView2, component: View2 },
  { path: linkPageView3, component: View3 },
  { path: linkPageView4, component: View4 },
  { path: linkPageCart, component: View4 },
  { path: linkPageFormNameCreate, component: FormAutomation },
  { path: linkPageFormNameView, component: FormAutomation },
  { path: linkPageBranchCreate, component: Branch },
  { path: linkPageBranchView, component: Branch },
  { path: linkPageMode, component: PageMode },
  {
    path: linkPageAudioAnalysis,
    component: PageAudioAnalysis,
  },
  {
    path: linkPageUploadAudio,
    component: PageUploadAudio,
  },
  {
    path: linkPageUnauthorized,
    name: linkNamePageUnauthorized,
    component: PageUnauthorized,
  },
];

export default routes;
